var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{ref:"toastEditor",attrs:{"initial-value":_vm.value,"options":_vm.editorOptions,"initial-edit-type":"wysiwyg"},on:{"blur":_vm.onEditorBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }